import { useQuery } from "@tanstack/react-query";
import { apiClient } from "./apiClient";
import { useSelector } from "react-redux";
import userSelector from "@/store/selectors/userSelector";
import { useGetActiveMunicipality } from "./getMunicipality";

export const useGetBuildingsExtended = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const user = useSelector(userSelector);
  const municipalityId = useGetActiveMunicipality({ enabled });

  return useQuery({
    queryKey: ['buildings/extended', municipalityId, user?.session_id],
    queryFn: async () => {
      if (!municipalityId) return [];
      const buildings = await apiClient.get('/buildings/:municipalityId/buildings/extended', {
        params: { municipalityId }
      });
      return buildings?.data.payload ?? [];
    },
    enabled: enabled && !!municipalityId && !!user?.verifiedEmail && !!user?.verifiedByAdmin,
  });
}
